import { reject } from 'lodash';
import * as authTypes from './authTypes';
export const login = (data, resolve, reject) => ({
  type: authTypes.LOGIN,
  data,
  resolve,
  reject,
});

export const logout = () => ({ type: authTypes.LOGOUT });

export const restoreSession = () => ({ type: authTypes.RESTORE_SESSION });

export const setAuthUser = (user) => ({ type: authTypes.SET_AUTH_USER, user });

export const setAuthUserPermissions = (permissions) => ({
  type: authTypes.SET_AUTH_USER_PERMISSIONS,
  permissions,
});

export const postOtpRequest = (contactNo, resolve, reject) => ({
  type: authTypes.POST_OTP_REQUEST,
  payload: { contactNo, resolve, reject }
})

export const postOtpWithLoginRequest = (data, resolve, reject) => ({
  type: authTypes.POST_LOGIN_WITH_OTP_REQUEST,
  payload: { data, resolve, reject }
})

export const postContactOtpRequest = (data, resolve, reject) => ({
  type: authTypes.POST_CONTACT_OTP_REQUEST,
  payload: { data, resolve, reject }
});

export const disconnectCalendarByIdRequest = (id, resolve, reject) => ({
  type: authTypes.DISCONNECT_CALENDAR_BY_ID_REQUEST,
  payload: { id, resolve, reject }
})
export const disconnectCalendarByIdSuccess = (id) => ({
  type: authTypes.DISCONNECT_CALENDAR_BY_ID_SUCCESS,
  payload: { id }
})
export const disconnectCalendarByIdFailure = (error) => ({
  type: authTypes.DISCONNECT_CALENDAR_BY_ID_FAILURE,
  payload: { error }
})

export const logDeviceInfo = (data, resolve, reject) => {
  console.log('[DeviceLog] Dispatching logDeviceInfo with data:', data);
  return {
    type: authTypes.LOG_DEVICE_INFO,
    payload: { data, resolve, reject }
  };
};

export const logDeviceInfoSuccess = (data) => ({
  type: authTypes.LOG_DEVICE_INFO_BY_ID_SUCCESS,
  payload: { data }
})
export const logDeviceInfoFailure = (error) => ({
  type: authTypes.LOG_DEVICE_INFO_BY_ID_FAILURE,
  payload: { error }
})
